import { Configuration, PaymentsApi } from '@/api';
import { PaymentMethods } from '@/models/PaymentMethod';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export const listPaymentMethodsQueryKey = ['payment-methods'];

const useListPaymentMethodsQuery = () => {
  const queryClient = useQueryClient();

  const paymentsApi = new PaymentsApi(new Configuration(useAuth));

  const {
    data: paymentMethods,
    isLoading,
    isFetching,
    error,
    refetch,
  } = useQuery<PaymentMethods>({
    queryKey: listPaymentMethodsQueryKey,
    queryFn: () => paymentsApi.listPaymentMethods(),
  });

  const invalidateQuery = async () => {
    await queryClient.invalidateQueries({ queryKey: listPaymentMethodsQueryKey });
  };

  return {
    paymentMethods,
    isLoading,
    isFetching,
    error,
    invalidateQuery,
    refetch,
  };
};

export default useListPaymentMethodsQuery;
